module.exports = __webpack_public_path__ + "img/1920_news_sub_img4.22fd2535.png";